import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { SectionHeading } from "./SectionHeading";
import { faqs } from "../data/page";
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-surface px-4 py-16 sm:px-6 sm:py-24" data-id="element-149" data-mp="1gjvjj8h09bic">
      <div className="mx-auto max-w-3xl" data-id="element-150" data-mp="248xyu9o62s9o">
        <SectionHeading title="Frequently asked questions" data-id="element-151" data-mp="24baqjejq8gzx" />

        <ul className="mt-10 space-y-3" data-id="element-152" data-mp="289qa18gln78l">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} className="overflow-hidden rounded-2xl bg-white ring-1 ring-navy-900/5" data-id="element-153" data-mp="1uhaeesq12bhp" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-accent" data-id="element-154" data-mp="1zgd6lckwsn89">
                  <span className="text-lg font-bold leading-snug text-ink" data-id="element-155" data-mp="10v9w89tt6ftq">{f.q}</span>
                  <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-[transform,background-color] duration-200 ease-out ${isOpen ? "rotate-45 bg-navy-900 text-white" : "bg-accent-soft text-navy-700"}`} data-id="element-156" data-mp="1em55hn87yyxu">
                    <PlusIcon className="h-5 w-5" aria-hidden="true" data-id="element-157" data-mp="1jjwwmf11ih0z" />
                  </span>
                </button>
                <AnimatePresence initial={false} data-id="element-158" data-mp="1xhlhvnz0rq6k">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-159" data-mp="1sis5jyvgy57z">
                      <p className="px-5 pb-5 text-base leading-relaxed text-ink-soft" data-id="element-160" data-mp="1ybfzktvaz8ne">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>

        <div className="mt-12" data-id="element-161" data-mp="2c94ivx9q27qc">
          <CtaButton label="I'm ready — get access" data-id="element-162" data-mp="2cafm9vz99dgx" />
        </div>
      </div>
    </section>;
}